import { ObjectLink, OverlapBadge, RunEntry, windowText } from './CalendarEntry.tsx';
import { dayLabel, daysOf, WEEKDAYS } from './dates.ts';
import { overlapsByDay, runsByDay, type CalendarBodyProps } from './WeekView.tsx';

/** Runs shown in a month cell; the rest open the week of that day. */
const CELL_LIMIT = 3;

/** Whole weeks of the month; send windows listed above the grid. */
export function MonthView({ environmentId, from, to, items, overlaps, today, month, onShowWeek }: CalendarBodyProps & { month: string; onShowWeek: (day: string) => void }) {
  const runs = runsByDay(items);
  const byDay = overlapsByDay(overlaps);
  const byKey = new Map(items.map((i) => [i.key, i]));
  const windows = items.filter((i) => i.kind === 'active_window');
  return (
    <div className="calendar-month">
      {windows.length > 0 && (
        <ul className="calendar-month__windows" aria-label="Active periods">
          {windows.map((w) => (
            <li key={w.key} className={`calendar__window calendar__window--${w.objectType}`}>
              <ObjectLink environmentId={environmentId} item={w} /> <span className="calendar__meta">{windowText(w)}</span>
            </li>
          ))}
        </ul>
      )}
      <div className="calendar-month__grid">
        {WEEKDAYS.map((d) => (
          <div key={d} className="calendar-month__weekday" aria-hidden="true">
            {d}
          </div>
        ))}
        {daysOf(from, to).map((day) => {
          const list = runs.get(day) ?? [];
          return (
            <section key={day} aria-label={dayLabel(day)} className={`calendar__day${day === today ? ' calendar__day--today' : ''}${day.slice(0, 7) === month.slice(0, 7) ? '' : ' calendar__day--outside'}`}>
              <header className="calendar__day-header">
                <span>{Number(day.slice(8))}</span>
                <OverlapBadge environmentId={environmentId} day={day} overlaps={byDay.get(day) ?? []} items={byKey} />
              </header>
              {list.length > 0 && (
                <ul className="calendar__runs">
                  {list.slice(0, CELL_LIMIT).map((item) => (
                    <RunEntry key={item.key} environmentId={environmentId} item={item} />
                  ))}
                </ul>
              )}
              {list.length > CELL_LIMIT && (
                <button type="button" className="calendar__more" onClick={() => onShowWeek(day)}>
                  +{list.length - CELL_LIMIT} more
                </button>
              )}
            </section>
          );
        })}
      </div>
    </div>
  );
}
